declare const Pollfish: any;
declare const pollfishConfig: PollFishConfig;


import { AppsData, Apps } from "@/constants/AppsData";
import { IAppConfigs } from "@/interfaces/IAppConfigs";
import { Environments } from "@/constants/Environments";
import { IToroxNetwork } from "@/interfaces/IToroxNetwork";
import { PollFishConfig } from "@/interfaces/PollFishConfig";
import { getStaticImagePaths } from "@/utils/getStaticImages";
import { NETWORK_DATA } from "@/constants/Networks/NetworkData";
import { NetworkNames } from "@/constants/Networks/NetworkNames";
import { IPollfishNetwork } from "@/interfaces/IPollfishNetwork";



const env = import.meta.env.VITE_APP_ENV as Environments;

if (!Object.values(Environments).includes(env)) {
    throw new Error(`Invalid environment: ${env}`);
}






const appName: Apps = import.meta.env.VITE_APP_NAME;

if (!(appName in Apps)) {
    throw new Error(`Invalid app name: ${appName}`);
}





const googleAppId = import.meta.env.VITE_APP_GOOGLE_CLIENT_ID;
const facebookAppId = import.meta.env.VITE_APP_FACEBOOK_CLIENT_ID;

if (!googleAppId || !facebookAppId) {
    throw new Error(`Invalid google or facebook app id`);
}



const googleRecaptchaSiteKey = import.meta.env.VITE_APP_GOOGLE_RECAPTCHA_SITE_KEY;

if (!googleRecaptchaSiteKey) {
    throw new Error(`Invalid google recaptcha site key`);
}




if (!import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_PROJECT_ID || !import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_MESSAGING_SENDER_ID || !import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_STORAGE_BUCKET || !import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_AUTH_DOMAIN || !import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_API_KEY || !import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_APP_ID) {
    throw new Error(`Invalid firebase configs for notifications`);
}




if (!import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_PROJECT_ID || !import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_MESSAGING_SENDER_ID || !import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_STORAGE_BUCKET || !import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_AUTH_DOMAIN || !import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_API_KEY || !import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_APP_ID) {
    throw new Error(`Invalid firebase configs for live user activity`);
}



const adgemWallCode = import.meta.env.VITE_APP_ADGEM_WALL_CODE;
const wannadsApiKey = import.meta.env.VITE_APP_WANNADS_API_KEY;
const toroxAppId = import.meta.env.VITE_APP_TOROX_APP_ID;
const toroxPubId = import.meta.env.VITE_APP_TOROX_PUB_ID;
const inbrainWallCode = import.meta.env.VITE_APP_INBRAIN_WALL_CODE;
const pollfishWallCode = import.meta.env.VITE_APP_POLLFISH_WALL_CODE;
const adgatemediaWallCode = import.meta.env.VITE_APP_ADGATEMEDIA_WALL_CODE;
const cpxresearchWallCode = import.meta.env.VITE_APP_CPXRESEARCH_WALL_CODE;
const lootablyPlacementID = import.meta.env.VITE_APP_LOOTABLY_PLACEMENT_ID;
const pollfishPlacementKey = import.meta.env.VITE_APP_POLLFISH_PLACEMENT_KEY;
const ayetstudiosAddSlotId = import.meta.env.VITE_APP_AYETSTUDIOS_ADDSLOT_ID;
const bitlabsToken = import.meta.env.VITE_APP_BITLABS_PLACEMENT_ID;
const timeWallToken = import.meta.env.VITE_APP_TIMEWALL_PLACEMENT_ID;
const adscendMediaID = import.meta.env.VITE_APP_ADSCENDMEDIA_PLACEMENT_ID;

if (!adgatemediaWallCode || !adgemWallCode || !cpxresearchWallCode || !inbrainWallCode || !pollfishWallCode || !pollfishPlacementKey || !ayetstudiosAddSlotId || !toroxAppId || !toroxPubId || !wannadsApiKey || !lootablyPlacementID || !bitlabsToken || !timeWallToken || !adscendMediaID) {
    throw new Error(`Invalid adgatemedia or adgem or cpxresearch or inbrain or pollfish wall code or pollfish placement key or ayetstudios add slot id or torox app id or torox pub id or wannads api key or lootably placement id or bitlabs token or adscendmedia id`);
}




const staticImages = Object.fromEntries(
    getStaticImagePaths()
)



export const AppConfigs: IAppConfigs = {
    appName: appName,
    googleAppId: googleAppId,
    facebookAppId: facebookAppId,
    appCode: AppsData[appName].appCode,
    googleReCaptchaSiteKey: googleRecaptchaSiteKey,
    protocol: env === Environments.Localhost ? 'http' : 'https',
    domain: env === Environments.Localhost ? 'cashout.localhost' : AppsData[appName].domain,
    subdomain: env === Environments.Localhost ? 'api' : (env === Environments.Production ? 'api' : 'api-dev-2'),


    notificationFirebaseConfig: {
        appId: import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_APP_ID,
        apiKey: import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_API_KEY,
        projectId: import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_PROJECT_ID,
        authDomain: import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_AUTH_DOMAIN,
        storageBucket: import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_STORAGE_BUCKET,
        messagingSenderId: import.meta.env.VITE_APP_NOTIFICATION_FIRESTORE_MESSAGING_SENDER_ID,
    },

    
    liveUserActivityFirebaseConfig: {
        appId: import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_APP_ID,
        apiKey: import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_API_KEY,
        projectId: import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_PROJECT_ID,
        authDomain: import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_AUTH_DOMAIN,
        storageBucket: import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_STORAGE_BUCKET,
        messagingSenderId: import.meta.env.VITE_APP_LIVE_USER_ACTIVITY_FIRESTORE_MESSAGING_SENDER_ID,
    },


    networks: {
        [NetworkNames.ADGATEMEDIA]: {
            wallCode: adgatemediaWallCode,
            wallBaseURL: NETWORK_DATA[NetworkNames.ADGATEMEDIA].url,
            image: staticImages[NetworkNames.ADGATEMEDIA.toUpperCase()],
            getWallURLByUserId: (userId: string) => `${NETWORK_DATA[NetworkNames.ADGATEMEDIA].url}/${adgatemediaWallCode}/${userId}`,
            rating: 5,
        },
        [NetworkNames.ADGEM]: {
            wallCode: adgemWallCode,
            wallBaseURL: NETWORK_DATA[NetworkNames.ADGEM].url,
            image: staticImages[NetworkNames.ADGEM.toUpperCase()],
            getWallURLByUserId: (userId: string) => `${NETWORK_DATA[NetworkNames.ADGEM].url}?appid=${adgemWallCode}&playerid=${userId}`,
            rating: 4.5,
        },
        [NetworkNames.CPXRESEARCH]: {
            wallCode: cpxresearchWallCode,
            wallBaseURL: NETWORK_DATA[NetworkNames.CPXRESEARCH].url,
            image: staticImages[NetworkNames.CPXRESEARCH.toUpperCase()],
            getWallURLByUserId: (userId: string) => `${NETWORK_DATA[NetworkNames.CPXRESEARCH].url}?app_id=${cpxresearchWallCode}&ext_user_id=${userId}`,
            rating: 5,
            promo: false,
        },
        [NetworkNames.INBRAIN]: {
            wallCode: inbrainWallCode,
            wallBaseURL: NETWORK_DATA[NetworkNames.INBRAIN].url,
            image: staticImages[NetworkNames.INBRAIN.toUpperCase()],
            getWallURLByUserId: (userId: string) => `${NETWORK_DATA[NetworkNames.INBRAIN].url}?params=${inbrainWallCode}&app_uid=${userId}`,
            rating: 3,
        },
        [NetworkNames.AYETSTUDIOS]: {
            wallCode: ayetstudiosAddSlotId,
            wallBaseURL: NETWORK_DATA[NetworkNames.AYETSTUDIOS].url,
            image: staticImages[NetworkNames.AYETSTUDIOS.toUpperCase()],
            getWallURLByUserId: (userId: string) => `${NETWORK_DATA[NetworkNames.AYETSTUDIOS].url}/${ayetstudiosAddSlotId}?external_identifier=${userId}`,
            rating: 5,
        },
        [NetworkNames.POLLFISH]: {
            wallCode: pollfishWallCode,
            placement_key: pollfishPlacementKey,
            wallBaseURL: NETWORK_DATA[NetworkNames.POLLFISH].url,
            image: staticImages[NetworkNames.POLLFISH.toUpperCase()],
            getWallURLByUserId: (userId: string) => {


                pollfishConfig.user_id = userId;


                Pollfish.showFullSurvey();


                return `${NETWORK_DATA[NetworkNames.POLLFISH].url}`;
            },
            rating: 4,
        } as IPollfishNetwork,
        [NetworkNames.TOROX]: {
            pubId: toroxPubId,
            wallCode: toroxAppId,
            wallBaseURL: NETWORK_DATA[NetworkNames.TOROX].url,
            image: staticImages[NetworkNames.TOROX.toUpperCase()],
            getWallURLByUserId: (userId: string) => `${NETWORK_DATA[NetworkNames.TOROX].url}/${toroxPubId}/${userId}/${toroxAppId}`,
            rating: 5,
        } as IToroxNetwork,
        [NetworkNames.WANNADS]: {
            wallCode: wannadsApiKey,
            wallBaseURL: NETWORK_DATA[NetworkNames.WANNADS].url,
            image: staticImages[NetworkNames.WANNADS.toUpperCase()],
            getWallURLByUserId: (userId: string) => `${NETWORK_DATA[NetworkNames.WANNADS].url}?apiKey=${wannadsApiKey}&userId=${userId}`,
            rating: 4,
        },
        [NetworkNames.LOOTABLY]: {
            wallBaseURL: NETWORK_DATA[NetworkNames.LOOTABLY].url,
            wallCode: lootablyPlacementID,
            image: staticImages[NetworkNames.LOOTABLY.toUpperCase()],
            getWallURLByUserId: (userId: string) => `${NETWORK_DATA[NetworkNames.LOOTABLY].url}?placementID=${lootablyPlacementID}&sid=${userId}`,
            rating: 0,
        },
        [NetworkNames.BITLABS]: {
            wallBaseURL: NETWORK_DATA[NetworkNames.BITLABS].url,
            wallCode: bitlabsToken,
            image: staticImages[NetworkNames.BITLABS.toUpperCase()],
            getWallURLByUserId: (userId: string) => `${NETWORK_DATA[NetworkNames.BITLABS].url}?token=${bitlabsToken}&uid=${userId}`,
            rating: 0,
        },
        [NetworkNames.TIMEWALL]: {
            wallBaseURL: NETWORK_DATA[NetworkNames.TIMEWALL].url,
            wallCode: bitlabsToken,
            image: staticImages[NetworkNames.TIMEWALL.toUpperCase()],
            getWallURLByUserId: (userId: string) => `${NETWORK_DATA[NetworkNames.TIMEWALL].url}?oid=${timeWallToken}&uid=${userId}`,
            rating: 0,
        },
        [NetworkNames.ADSCENDMEDIA]: {
            wallBaseURL: NETWORK_DATA[NetworkNames.ADSCENDMEDIA].url,
            wallCode: bitlabsToken,
            image: staticImages[NetworkNames.ADSCENDMEDIA.toUpperCase()],
            getWallURLByUserId: (userId: string) => `${NETWORK_DATA[NetworkNames.ADSCENDMEDIA].url}${adscendMediaID}?subid1=${userId}`,
            rating: 4,
        },
    }, 



    staticImages,



};


export const API_BASE_URL = `${AppConfigs.protocol}://${AppConfigs.subdomain}.${AppConfigs.domain}/v2.10`;


